import { Injectable } from '@angular/core';
import { of, Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import type { ExternalServicesAvailability } from 'src/app/models/external-systems';

@Injectable({
  providedIn: 'root'
})
export class ExternalSystemsService {
  constructor(private api: ApiService) { }

  get(): Observable<ExternalServicesAvailability> {
    return this.api.get(`query externalServices {
        externalServices {
          ibanValidator {
            enabled
          }
        }
      }`).pipe(
      switchMap(response => {
        if (response['errors']) {
          return throwError(response);
        }

        return of(response['data']['externalServices']);
      }),
      this.api.unifyErrors()
    );
  }
}
